function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DF5F4E"
    },
    points: "386.728,197.957 501.541,197.957 470.739,286.869 501.48,375.747 386.728,375.747  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DF5F4E"
    },
    points: "125.272,375.747 10.458,375.747 41.26,286.836 10.519,197.957 125.272,197.957  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.269,
    y: 136.251,
    style: {
      fill: "#ECF0F1"
    },
    width: 41.833,
    height: 177.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.892,
    y: 136.251,
    style: {
      fill: "#ECF0F1"
    },
    width: 41.833,
    height: 177.79
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.102,
    y: 136.251,
    style: {
      fill: "#DF5F4E"
    },
    width: 177.79,
    height: 177.79
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M481.806,286.348l29.618-85.491c1.108-3.197,0.6-6.471-1.363-9.227 c-1.962-2.757-5.136-4.132-8.519-4.132H397.186V135.73c0-5.776-4.455-9.935-10.231-9.935H125.499 c-5.776,0-10.685,4.159-10.685,9.935v51.768H10.519c-3.382,0-6.556,1.374-8.518,4.13c-1.962,2.755-2.471,6.159-1.366,9.355 l29.558,85.392l-29.617,85.46c-1.108,3.197-0.6,6.977,1.363,9.733c1.962,2.757,5.136,4.638,8.519,4.638h115.041 c5.776,0,10.231-5.205,10.231-10.981v-50.722h240.54v50.722c0,5.776,4.909,10.981,10.685,10.981H501.48 c3.382,0,6.556-1.897,8.518-4.653c1.962-2.755,2.471-6.42,1.366-9.616L481.806,286.348z M114.814,365.289H25.149l25.993-75.292 c0.768-2.216,0.768-4.495,0.001-6.711l-25.942-74.871h89.611v156.874H114.814z M135.73,197.434v-50.722h20.916v156.874H135.73 V197.434z M177.563,146.712h156.874v156.874H177.563L177.563,146.712L177.563,146.712z M355.353,303.586V146.712h20.916v50.722 v106.151H355.353z M397.186,365.289V208.416h89.664l-25.993,74.769c-0.768,2.216-0.768,4.756-0.001,6.972l25.942,75.132H397.186z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/Banner.5e5f836d85fa8ebde0188ee94a2424c1.svg";
export { ForwardRef as ReactComponent };